import { BaseRule } from "./BaseRule";
import ValidatorsFactory from "./ValidatorsFactory";

export type ValidatorResultType = {
	isValid: boolean;
	errorMessage: string;
};

export class Validator {

	rules: Array<BaseRule> = [];

	constructor ( rules: Array<BaseRule> ) {
		this.rules = rules;
	};

	isValid = ( value: any ): ValidatorResultType => {
		for ( let i = 0; i < this.rules.length; i++) {
			const validRes = this.rules[i].isValid(value);
			if ( validRes.isValid === false ) {
				return validRes;
			}
		}
		return BaseRule.getValidationResult( true );
	};

};

export default ValidatorsFactory;
